import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["DraftyLogo"] */ "/opt/build/repo/src/components/drafty-logo.tsx");
